import React from "react"

import Layout from '../components/layout/layout'
import {locales} from "../utils/getCurrentLocale";


const Main = (props) => {

    if (typeof window !== 'undefined')
    {
        const lang = navigator.language.split('-')[0];
        const newLocation = Object.keys(locales).includes(lang) ? `/docs/${lang}/start-page` : `/docs/en/start-page`;
        window.location.replace(newLocation);
    }

    return (
        <Layout location={props.location}>

        </Layout>
    )
};

export default Main
